import { IFieldArray } from "AngularFormly";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../../../utils";
import {
  IRecordRepeaterScope,
  IRecordRepeaterTemplateOptions,
  RecordRepeaterController,
  RowState,
} from "./controller";

export interface IRecordEditRepeaterTemplateOptions
  extends IRecordRepeaterTemplateOptions {
  editFields: IFieldArray;
}

export class RecordEditRepeaterController extends RecordRepeaterController {
  static $inject = ["$scope", RecordsUtilsServiceName];

  constructor($scope: IRecordRepeaterScope, recordUtils: RecordsUtilsService) {
    super($scope, recordUtils);
  }

  edit(model: any): void {
    this.resetRowState(this.rowState[this.getRowIndex(model)], true);
  }

  editComplete(model: any): void {
    this.resetRowState(this.rowState[this.getRowIndex(model)], false);
  }

  override addRow(model?: any): void {
    const newModel = super.addRow(model);
    this.resetRowState(this.rowState[this.getRowIndex(newModel)], true);
  }

  private resetRowState(rowState: RowState, editing: boolean): void {
    const index = this.rowState.indexOf(rowState);
    const newRowState = this.buildRowState(
      index,
      editing
        ? this.templateOptions.editFields
        : this.templateOptions.repeaterFields
    );
    newRowState.editing = editing;
    this.rowState[index] = newRowState;
  }
}
